import { AppBar, Box, Container, NoSsr, Toolbar } from '@mui/material';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import LanguagePickerButton from 'components/@common/LanguagePickerButton';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import LoadingScreen from 'components/@common/LoadingScreen';
import HideOnScroll from 'components/@navigation/HideOnScroll';
import LogoNofomo from 'components/@navigation/LogoNofomo';

interface Props {
  isLoading?: boolean;
  children: ReactNode;
  secondaryImage?: ReactNode;
}

const AppCompactNavigation = ({
  children,
  secondaryImage,
  isLoading,
}: Props) => {
  const intl = useIntl();

  return (
    <>
      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <HideOnScroll>
          <AppBar color="default">
            <Container sx={{ p: { xs: 0 } }}>
              <Toolbar sx={{ justifyContent: 'space-between', p: 2, gap: 1 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Box
                    aria-label={intl.formatMessage({
                      id: 'navigation.home',
                      defaultMessage: 'Home',
                    })}
                    component={LinkUnstyled}
                    href={Routes.Home}
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <LogoNofomo />
                  </Box>
                  {secondaryImage}
                </Box>

                <LanguagePickerButton />
              </Toolbar>
            </Container>
          </AppBar>
        </HideOnScroll>
        <Toolbar sx={{ minHeight: 72 }} />
      </Box>
      <NoSsr fallback={<LoadingScreen />}>
        {isLoading ? <LoadingScreen /> : <>{children}</>}
      </NoSsr>
    </>
  );
};

export default AppCompactNavigation;
